const DOMAIN = process.env.REACT_APP_DOMAIN || window.location.hostname;
const OKTA_CLIENT_ID = process.env.REACT_APP_OKTA_CLIENT_ID || '';
const OKTA_ISSUER = process.env.REACT_APP_OKTA_ISSUER || '';
const API_URL = (process.env.REACT_APP_API_URL || '').trim();
const GTM_CONTAINER_ID = process.env.REACT_APP_GTM_CONTAINER_ID || '';

// Use proxy server in development to avoid CORS issues
const isDevelopment = process.env.NODE_ENV === 'development';
const EFFECTIVE_API_URL = API_URL;

export const appConfig = {
  isProd: DOMAIN === 'marketplace.elluciancloud.com',

  okta: {
    clientId: OKTA_CLIENT_ID,
    issuer: OKTA_ISSUER,
    redirectUri: `https://${DOMAIN}/login/callback`,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    tokenManager: { storage: "localStorage", secure: false }
  },

  api: {
    baseUrl: EFFECTIVE_API_URL,
    loginEndpoint: '/api/login',
    solutionsEndpoint: '/api/solutions'
  },

  logout: {
    baseUrl: OKTA_ISSUER + '/oauth2/v1/logout',
    redirectUri: `https://${DOMAIN}/logout`
  },

  analytics: {
    gtmContainerId: GTM_CONTAINER_ID,
    enabled: !!GTM_CONTAINER_ID
  },

  domain: DOMAIN
};

export default appConfig;